const sido = {
  KT: ['서울특별시', '경기도', '강원도', '인천광역시'],
  HELLO: [
    '서울특별시',
    '인천광역시',
    '경기도',
    '부산광역시',
    '경상남도',
    '경상북도',
    '대구광역시',
    '전라남도',
    '전라북도',
    '충청남도',
    '강원도',
  ],
};

const ableArea = {
  HELLO: [
    {
      sido: '서울특별시',
      sigungu: ['양천구', '은평구'],
    },
    {
      sido: '인천광역시',
      sigungu: ['계양부', '부평구'],
    },
    {
      sido: '경기도',
      sigungu: [
        '김포시',
        '동두천시',
        '부천시',
        '양주시',
        '연천군',
        '의정부시',
        '포천시',
      ],
    },
    {
      sido: '부산광역시',
      sigungu: [
        '금정구',
        '기장군',
        '동구',
        '부산진구',
        '영도구',
        '중구',
        '해운대구',
      ],
    },
    {
      sido: '경상남도',
      sigungu: [
        '거제시',
        '거창군',
        '고성군',
        '김해시',
        '밀양시',
        '양산시',
        '의령군',
        '창녕군',
        '창원시',
        '통영시',
        '함안군',
        '합천군',
      ],
    },
    {
      sido: '경상북도',
      sigungu: [
        '경산시',
        '경주시',
        '문경시',
        '봉화군',
        '안동시',
        '영양군',
        '영주시',
        '영천시',
        '예천군',
        '의성군',
        '청도군',
        '청송군',
      ],
    },
    {
      sido: '대구광역시',
      sigungu: ['동구', '수성구'],
    },
    {
      sido: '전라남도',
      sigungu: [
        '강진군',
        '고흥군',
        '광양시',
        '목포시',
        '무안군',
        '순천시',
        '신안군',
        '여수시',
        '영암군',
        '완도군',
        '장흥군',
        '진도군',
        '해남군',
      ],
    },
    {
      sido: '전라북도',
      sigungu: [
        '고창군',
        '김제시',
        '남원시',
        '부안군',
        '순창군',
        '임실군',
        '정읍시',
      ],
    },
    {
      sido: '충청남도',
      sigungu: ['당진시', '서산시', '예산군', '청양군', '태안군', '홍성군'],
    },
    {
      sido: '강원도',
      sigungu: [''],
    },
  ],
};

const price = {
  KT: [
    {
      item: '100M+TV',
      monthOrg: 39600,
      monthSale: 29600,
      support: 360000,
      gift: 60000,
    },
    {
      item: '500M+TV',
      monthOrg: 49500,
      monthSale: 35100,
      support: 518400,
      gift: 70000,
    },
    {
      item: '100M',
      monthOrg: 23100,
      monthSale: 17600,
      support: 198000,
      gift: 40000,
    },
  ],
};

export default {
  getSidoCheck(telecom, areaSido) {
    return sido[telecom].includes(areaSido);
  },
  getSigungu(telecom, areaSido, areaSigungu) {
    const foundInfo = ableArea[telecom].find(info => info.sido === areaSido);

    console.log('foundInfofoundInfofoundInfo');
    console.log(foundInfo);

    // 전체 구
    if (foundInfo.sigungu[0] == '') {
      return true;
    } else if (foundInfo.sigungu.includes(areaSigungu)) {
      return true;
    } else {
      return false;
    }
  },
  getPriceInfo(telecom, item) {
    const foundInfo = price[telecom].find(info => info.item === item);

    return foundInfo;
  },
  getMonthOrgPrice(telecom, item) {
    const foundInfo = price[telecom].find(info => info.item === item);

    return foundInfo.monthOrg;
  },
  getMonthSalePrice(telecom, item) {
    const foundInfo = price[telecom].find(info => info.item === item);

    return foundInfo.monthSale;
  },
  getMonthSupportPrice(telecom, item) {
    const foundInfo = price[telecom].find(info => info.item === item);

    return foundInfo.support;
  },
  getMonthGiftPrice(telecom, item) {
    const foundInfo = price[telecom].find(info => info.item === item);

    return foundInfo.gift;
  },
};
